import { render, staticRenderFns } from "./clientProfileReport.vue?vue&type=template&id=31bdbe00&scoped=true"
import script from "./clientProfileReport.vue?vue&type=script&lang=js"
export * from "./clientProfileReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bdbe00",
  null
  
)

export default component.exports